(function(){
'use strict';
var CID='R4FfmD',LID='ThrUFN',API='https://a.klaviyo.com/client/',H={'Content-Type':'application/json',revision:'2024-10-15'};
var root,overlay,modal,closeBtn,inp,errEl,stepE,stepS,stepX,btnE,btnD,scentBtns,badge;
var open=false,em='',sc=[],sy=0,closeTm=null,showTime=0;

function ls(k,v){try{return v===void 0?localStorage.getItem(k):localStorage.setItem(k,v)}catch(e){return null}}
function ss(k,v){try{return v===void 0?sessionStorage.getItem(k):sessionStorage.setItem(k,v)}catch(e){return null}}
function sub(){return ls('fp_s')==='1'}
function dis(){var t=parseInt(ls('fp_d'),10);return t>0&&Date.now()-t<12096e5}
function excl(){var p=location.pathname;return p.indexOf('/pages/find-your-fumo')===0||p.indexOf('/policies/')===0||p.indexOf('/checkout')===0}
function srch(){var n=parseInt(ss('fp_p'),10)||0;ss('fp_p',String(n+1));if(n>0)return false;var r=document.referrer;return['google.','bing.com','yahoo.com','duckduckgo.com'].some(function(d){return r.indexOf(d)!==-1})}

function lock(){sy=window.pageYOffset;var s=document.body.style;s.overflow='hidden';s.position='fixed';s.top=-sy+'px';s.width='100%'}
function unlock(){var s=document.body.style;s.overflow=s.position=s.top=s.width='';window.scrollTo(0,sy)}
function inert(on){['#MainContent','#header-group','#shopify-section-footer','[id*="footer-group"]'].forEach(function(q){var e=document.querySelector(q);if(e)on?e.setAttribute('inert',''):e.removeAttribute('inert')})}
function step(el){[stepE,stepS,stepX].forEach(function(s){if(s)s.classList.remove('is-active')});if(el)el.classList.add('is-active')}

function show(){
if(open)return;
open=true;
if(badge)badge.classList.remove('is-visible');
if(closeBtn)closeBtn.style.opacity='0';
if(closeTm)clearTimeout(closeTm);
closeTm=setTimeout(function(){if(closeBtn)closeBtn.style.opacity='1'},2000);
showTime=Date.now();lock();inert(true);root.classList.add('is-active');root.setAttribute('aria-hidden','false');step(stepE);
if(window.innerWidth>768&&inp)requestAnimationFrame(function(){inp.focus()});
}

function hide(){
if(!open)return;open=false;
if(closeTm){clearTimeout(closeTm);closeTm=null}
if(closeBtn)closeBtn.style.opacity='';
root.classList.remove('is-active');root.setAttribute('aria-hidden','true');unlock();inert(false);
}

function minimize(){
if(Date.now()-showTime<500)return;
hide();
if(badge)badge.classList.add('is-visible');
if(!em)ls('fp_d',String(Date.now()));
}

function trap(e){
if(!open||e.key!=='Tab')return;
var f=modal.querySelectorAll('button:not([disabled]),input:not([disabled]):not([tabindex="-1"])');
if(!f.length)return;var a=f[0],z=f[f.length-1];
if(e.shiftKey&&document.activeElement===a){e.preventDefault();z.focus()}
else if(!e.shiftKey&&document.activeElement===z){e.preventDefault();a.focus()}
}

function sendEmail(){
var v=inp?inp.value.trim():'';
if(!v||!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)){if(errEl)errEl.setAttribute('data-visible','true');if(inp)inp.focus();return}
var hp=root.querySelector('[data-fumo-hp]');if(hp&&hp.value)return;
if(errEl)errEl.setAttribute('data-visible','false');
if(btnE){btnE.disabled=true;btnE.textContent='Sending...'}
em=v;
fetch(API+'subscriptions/?company_id='+CID,{method:'POST',headers:H,body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'Founders Circle Popup',profile:{data:{type:'profile',attributes:{email:v,properties:{signup_source:'popup',founders_circle:true}}}}},relationships:{list:{data:{type:'list',id:LID}}}}})})
.then(function(r){if(!r.ok&&r.status!==202)throw 0;step(stepS)})
.catch(function(){if(btnE){btnE.disabled=false;btnE.textContent='JOIN THE FOUNDERS CIRCLE'}if(errEl){errEl.textContent='Something went wrong. Please try again.';errEl.setAttribute('data-visible','true')}});
}

function sendScents(){
if(!em)return;if(btnD)btnD.disabled=true;
fetch(API+'profiles/?company_id='+CID,{method:'POST',headers:H,body:JSON.stringify({data:{type:'profile',attributes:{email:em,properties:{scent_preference:sc,founders_circle:true}}}})}).then(done).catch(done);
}
function done(){ls('fp_s','1');step(stepX);setTimeout(function(){hide();if(badge)badge.classList.remove('is-visible')},2500)}

function init(){
root=document.querySelector('.fumo-popup');
if(!root||sub()||excl()||srch())return;
overlay=root.querySelector('.fumo-popup__overlay');
modal=root.querySelector('.fumo-popup__modal');
closeBtn=root.querySelector('.fumo-popup__close');
inp=root.querySelector('.fumo-popup__input');
errEl=root.querySelector('.fumo-popup__error');
btnE=root.querySelector('[data-popup-submit-email]');
btnD=root.querySelector('[data-popup-complete]');
scentBtns=root.querySelectorAll('.fumo-popup__scent-btn');
stepE=root.querySelector('[data-popup-step="email"]');
stepS=root.querySelector('[data-popup-step="scent"]');
stepX=root.querySelector('[data-popup-step="success"]');
badge=root.querySelector('.fumo-popup__badge');
var badgeLabel=badge?badge.querySelector('.fumo-popup__badge-label'):null;
var badgeClose=badge?badge.querySelector('.fumo-popup__badge-close'):null;
function onBadgeOpen(e){e.preventDefault();e.stopPropagation();show()}
function onBadgeDismiss(e){e.preventDefault();e.stopPropagation();if(badge)badge.classList.remove('is-visible');ls('fp_d',String(Date.now()))}
if(badgeLabel){badgeLabel.addEventListener('click',onBadgeOpen);badgeLabel.addEventListener('touchend',onBadgeOpen)}
if(badgeClose){badgeClose.addEventListener('click',onBadgeDismiss);badgeClose.addEventListener('touchend',onBadgeDismiss)}
if(modal)modal.addEventListener('click',function(e){e.stopPropagation()});
if(overlay){overlay.addEventListener('click',minimize);overlay.addEventListener('touchend',function(e){e.preventDefault();minimize()})}
if(closeBtn){closeBtn.addEventListener('click',function(e){e.stopPropagation();minimize()});closeBtn.addEventListener('touchend',function(e){e.preventDefault();e.stopPropagation();minimize()})}
if(btnE)btnE.addEventListener('click',function(e){e.preventDefault();sendEmail()});
if(inp){inp.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();sendEmail()}});inp.addEventListener('focus',function(){if(errEl)errEl.setAttribute('data-visible','false')})}
scentBtns.forEach(function(b){b.addEventListener('click',function(){var s=b.getAttribute('data-scent'),on=b.getAttribute('aria-pressed')==='true';b.setAttribute('aria-pressed',on?'false':'true');sc=on?sc.filter(function(x){return x!==s}):sc.concat(s)})});
if(btnD)btnD.addEventListener('click',function(e){e.preventDefault();sendScents()});
var sk=root.querySelector('[data-popup-skip]');if(sk)sk.addEventListener('click',function(e){e.preventDefault();done()});
document.addEventListener('keydown',function(e){if(e.key==='Escape'&&open)minimize();trap(e)});
if(dis()){if(badge)badge.classList.add('is-visible');return}
setTimeout(show,2000);
}
document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();
})();
